import React from 'react';
import { CardBody } from 'reactstrap';
import HolidaysTable from './components/MatrixSLAHolidaysTable';
import DefaultModal from 'components/Modal/DefaultModal';

const MatrixSLAHolidays = ({
  isModalOpen,
  onModalToggle,
  matrixSLAId,
  ...props
}) => {
  return (
    <>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={onModalToggle}
        title="Feriados da Matriz de SLA"
        showCloseButton={false}
        modalContainerClasses="modal-xl"
        {...props}
      >
        <CardBody>
          <HolidaysTable matrixSLAId={matrixSLAId} />
        </CardBody>
      </DefaultModal>
    </>
  );
};

export default MatrixSLAHolidays;
